export default "__VITE_ASSET__TkNontyW__"